<p-toast></p-toast>
<div class="grid">
    <div class="col-12">
        <div class="card">
            <h5 *ngIf="!objeto.id">Nueva Notificación</h5>
            <h5 *ngIf="objeto.id">Notificación: {{ objeto.nombre }}</h5>
            <app-cabecera-ventana *ngIf="!loading" 
                [modulo]="modulo" [codigoRegistro]="codigoRegistro" [readonly]="isReadonly()" [esNuevo]="esNuevo()" [activo]="objeto?.activo" [cargando]="cargando"
                (eVolver)="volver()" (eNuevo)="nuevo()" (eEditar)="editar()" (eGuardar)="guardar()" (eEliminar)="eliminar()" (eInactivar)="inactivar($event)">
            </app-cabecera-ventana>
            <div *ngIf="loading" class="flex justify-content-center flex-wrap">
                <p-progressSpinner></p-progressSpinner>
            </div>
            <form *ngIf="!loading" [formGroup]="formGroup">
                <p-tabView>
                    <p-tabPanel header="General">
                        <div class="p-fluid p-formgrid grid">
                            <div class="field col-12 md:col-8">
                                <div *ngIf="currentUser.superusuario" class="p-fluid p-formgrid grid">
                                    <div class="field col-12 md:col-3">
                                        <label htmlFor="id_empresa">Empresa</label>
                                        <span class="p-input-icon-right">
                                            <input pInputText id="id_empresa" type="text" formControlName="id_empresa" (change)="onEmpresa()" (keydown.control.enter)="!isReadonly() ? onListaEmpresa() : ''" [readOnly]="isReadonly()" />
                                            <i *ngIf="!isReadonly()" style="font-size: 1.2rem;" class="pi pi-search" (click)="onListaEmpresa()"></i>
                                        </span>
                                    </div>
                                    <div class="field col-12 md:col-4">
                                        <label htmlFor="nombre_empresa">Descripción</label>
                                        <input pInputText id="nombre_empresa" type="text" formControlName="nombre_empresa" readonly />
                                    </div>
                                </div>
                                <div class="grid">
                                    <div class="field col-12 md:col-3">
                                        <label htmlFor="fecha">Fecha </label>
                                        <p-calendar id="fecha" formControlName="fecha" [showTime]="true" dateFormat="dd/mm/yy" [disabled]="isReadonly()"></p-calendar>
                                    </div>
                                    <div class="field col-12 md:col-3">
                                        <label htmlFor="tipo">Tipo</label>
                                        <p-dropdown [options]="tipos" formControlName="tipo" optionLabel="nombre" optionValue="valor" [readonly]="isReadonly()" ></p-dropdown>
                                    </div>
                                    <div class="field col-12 md:col-6">
                                        <label htmlFor="nombre">Nombre/Asunto</label>
                                        <input pInputText id="nombre" type="text" formControlName="nombre" [readOnly]="isReadonly()" />
                                        <small *ngIf="invalidControl('nombre')" style="color: red;">Este campo es requerido.</small>
                                    </div>
                                    <div class="field col-12 md:col-12">
                                        <label htmlFor="descripcion">Descripción</label>
                                        <input pInputText id="descripcion" type="text" formControlName="descripcion" [readOnly]="isReadonly()"/>
                                    </div>
                                    <div class="field col-12 md:col-2">
                                        <label htmlFor="total_enviado">Enviados</label>
                                        <p-inputNumber inputId="total_enviado" formControlName="total_enviado" [readonly]="isReadonly()" ></p-inputNumber>
                                    </div>
                                    <div class="field col-12 md:col-2">
                                        <label htmlFor="total_no_enviado">No Enviados</label>
                                        <p-inputNumber inputId="total_no_enviado" formControlName="total_no_enviado" [readonly]="isReadonly()" ></p-inputNumber>
                                    </div>
                                    <!-- Estado real del envio. Vive en el job, no en la campania. -->
                                    <div class="field col-12 md:col-8" *ngIf="estadoEnvio">
                                        <label>Estado del envío</label>
                                        <div class="flex align-items-center gap-3 flex-wrap">
                                            <span class="custom-badge"
                                                  [class.status-unqualified]="estadoEnvio.interrumpida || estadoEnvio.estado === 'fallido'"
                                                  [class.status-qualified]="!estadoEnvio.interrumpida && estadoEnvio.estado !== 'fallido'">
                                                {{ estadoEnvio.resumen }}
                                            </span>
                                            <button *ngIf="estadoEnvio.retomable"
                                                    pButton type="button"
                                                    icon="pi pi-replay"
                                                    label="Retomar envío"
                                                    class="p-button-sm"
                                                    [loading]="retomando"
                                                    (click)="onRetomarEnvio()"></button>
                                        </div>
                                        <small *ngIf="estadoEnvio.error_mensaje" style="color: red;">
                                            {{ estadoEnvio.error_mensaje }}
                                        </small>
                                        <small *ngIf="estadoEnvio.retomable">
                                            Al retomar, quien ya recibió el mensaje no lo recibe de nuevo.
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="field col-12 md:col-4" *ngIf="objeto.archivo">
                                <div class="field grid flex justify-content-center">
                                    <div *ngIf="objeto.archivo" class="col-12 md:col-4">
                                        <h5 class="flex justify-content-center">Imagen</h5>
                                        <div class=" flex justify-content-center">
                                            <p-image [preview]="true" [src]="urlImage + objeto.nombreEmpresa + '/' + objeto.archivo"  alt="Image" width="190"></p-image>
                                        </div>
                                    </div>
                                </div> 
                            </div>
                        </div>
                        <div class="p-fluid p-formgrid grid">
                            <div class="col-12 md:col-4">
                                <div class="field-checkbox">
                                    <p-checkbox name="activo" id="activo" [binary]="true" formControlName="activo" [readonly]="true"></p-checkbox>
                                    <label for="activo">Activo</label>
                                </div>
                            </div>
                        </div>
                    </p-tabPanel>
                    <p-tabPanel header="Auditoria">
                        <div class="p-fluid p-formgrid grid">
                            <div class="field col-12 md:col-4">
                                <label htmlFor="nombre_creado_por">Creado por</label>
                                <input pInputText id="cod_creado_por" type="text" formControlName="cod_creado_por" readonly />
                            </div>
                            <div class="field col-12 md:col-4">
                                <label htmlFor="fecha_creacion">Fecha Creación</label>
                                <p-calendar id="fecha_creacion" formControlName="fecha_creacion" [showTime]="true" dateFormat="dd/mm/yy" disabled="true"></p-calendar>
                            </div>
                        </div>
                        <div class="p-fluid p-formgrid grid">
                            <div class="field col-12 md:col-4">
                                <label htmlFor="cod_actualizado_por">Actualizado por</label>
                                <input pInputText id="cod_actualizado_por" type="text" formControlName="cod_actualizado_por" readonly />
                            </div>
                            <div class="field col-12 md:col-4">
                                <label htmlFor="fecha_actualizacion">Fecha Actualización</label>
                                <p-calendar id="fecha_actualizacion" formControlName="fecha_actualizacion" [showTime]="true" dateFormat="dd/mm/yy" disabled="true"></p-calendar>
                            </div>
                        </div>
                        <div class="p-fluid p-formgrid grid">
                            <div class="field col-12 md:col-4">
                                <label htmlFor="cod_inactivado_por">Inactivado por</label>
                                <input pInputText id="cod_inactivado_por" type="text" formControlName="cod_inactivado_por" readonly />
                            </div>
                            <div class="field col-12 md:col-4">
                                <label htmlFor="fecha_inactivacion">Fecha Inactivación</label>
                                <p-calendar id="fecha_inactivacion" formControlName="fecha_inactivacion" [showTime]="true" dateFormat="dd/mm/yy" disabled="true"></p-calendar>
                            </div>
                        </div>
                    </p-tabPanel>
                </p-tabView>
            </form>
        </div>
    </div>
</div>
<app-on-lista [show]="showOnLista" [title]="tituloOnLista" [columns]="columnasOnLista" [service]="serviceOnLista" [recordName]="recordNameOnLista"
    (close)="cerrarOnLista($event)">
</app-on-lista>